
import { Vue, Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { ClickoutUrl } from '@/helpers/clickout-helper';
import { COUNTRY_WITHOUT_TITLEDETAIL } from '@/constants/web-locales.constant';
import type { WebLocale } from '@/enums/web-locale';

const Language = namespace('language');

@Component({
	name: 'TitleDetailLink',
})
export default class TitleDetailLink extends Vue {
	@Prop() title: any;
	@Prop() offer: any;
	@Prop({ required: true }) fullPath: string;

	@Language.State webLocale: WebLocale;

	get titleUrlsEnabled() {
		return !COUNTRY_WITHOUT_TITLEDETAIL.includes(this.webLocale);
	}

	get isExternalLink() {
		return /^(http|https|www)/i.test(this.fullPath);
	}

	async onClick(evt: Event) {
		if (!this.titleUrlsEnabled && this.title) {
			// open up buybox modal if the country doesn't have title detail pages
			evt.preventDefault();
			const { default: WatchNowModal } = await import('@/components/modals/WatchNowModal.vue');
			const { ModalHelper } = await import('@/helpers/modal-helper');
			ModalHelper.openModal(WatchNowModal, {
				title: this.title,
			});
		}
	}

	// means that there is no title detail page for that country.
	get directClickoutUrl() {
		if ((!this.offer || !this.offer?.standardWebURL) && !this.titleUrlsEnabled) return null;
		return new ClickoutUrl(this.offer).toString();
	}

	// For external links
	onClickOut() {
		this.$emit('clickOut');
	}
}
